const imageMixin = {
  methods: {
    /**
     * Generate the url to an image
     *
     * @param {string} url - Base image url
     * @param {string} size - Image size. Either small, medium, large or original
     *
     * @returns null|string
     */
    getImageUrl (url, size = 'medium') {
      if (url) {
        return `${url}?size=${size}`
      }

      return null
    }
  }
}

export default imageMixin
